import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=0513a826"
import script from "./ModalWindow.vue?vue&type=script&lang=js"
export * from "./ModalWindow.vue?vue&type=script&lang=js"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=0513a826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports